import React from "react";
import { TopicCitationsContext } from "../context/entity-collections";
export var useTopicCitations = function () {
  return React.useContext(TopicCitationsContext) || [];
};